<template>
  <v-modal
    ref="modal"
    target="sidebar-popup"
    close-on-backdrop-click
    transition-name="slide-right-to-left-to-right"
    v-bind="$attrs"
    :backdrop-styles="$options.backdropStyles"
  >
    <vue-perfect-scrollbar class="sidebar-popup">
      <close-button v-modal-submit class="sidebar-popup__close-button"></close-button>
      <div class="sidebar-popup__content">
        <slot></slot>
      </div>
    </vue-perfect-scrollbar>
  </v-modal>
</template>

<script>
import CloseButton from '@/components/common/CloseButton.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'SidebarPopup',
  components: { CloseButton, VuePerfectScrollbar },
  backdropStyles: {
    backgroundColor: '#000000',
    opacity: '0.25'
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    open() {
      return this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar-popup {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 600px;
  max-width: 100%;
  background-color: white;
  padding: 24px;

  &__close-button {
    --button-size: 40px;
    --icon-size: 11px;
    margin-bottom: 24px;
  }
}

@media (min-width: 960px) {
  .sidebar-popup {
    padding: 56px;

    &__close-button {
      --button-size: 50px;
      --icon-size: 14px;
    }
  }
}
</style>
